import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';
import { EmpresaBuscaPayload } from '../interfaces/empresa-busca-payload.interface';
import { EmpresaBuscaResponse } from '../interfaces/empresa-busca-response.interface';
import { EmpresaContatosPayload, EmpresaObrasPayload } from '../interfaces/empresa-detalhes.interface';
import { EditarBuscaEmpresaPayload, SalvarBuscaEmpresaPayload } from '../interfaces/empresa-busca-salva.interface';

@Injectable({
  providedIn: 'root',
})
export class EmpresaBuscaService {
  constructor(private readonly _requestService: RequestService) {}

  getSearchFilters(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/company/GetSearchFilters',
      'GET',
      true,
      null,
    );
  }

  getSearchStates(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/company/GetSearchStates',
      'GET',
      true,
      null,
    );
  }

  getSearchCities(ufCodigo: string | number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/company/GetSearchCities/${ufCodigo}`,
      'GET',
      true,
      null,
    );
  }

  searchCompanies(body: EmpresaBuscaPayload): Observable<EmpresaBuscaResponse> {
    return this._requestService.requestMethod(
      'company/api/company/SearchCompanies',
      'POST',
      true,
      body,
    );
  }

  getCompanyDetail(targetCompanyId: number, moduleId: string): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/company/GetCompanyDetail/${targetCompanyId}?moduleId=${moduleId}`,
      'GET',
      true,
      null,
    );
  }

  getCompanyContacts(body: EmpresaContatosPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/company/GetCompanyContacts',
      'POST',
      true,
      body,
    );
  }

  getCompanyWorks(body: EmpresaObrasPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/company/GetCompanyWorks',
      'POST',
      true,
      body,
    );
  }

  getCompanyPhasesByModule(targetCompanyId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/company/GetCompanyPhasesByModule/${targetCompanyId}`,
      'GET',
      true,
      null,
    );
  }

  getCompanyWorksRealEstate(body: EmpresaObrasPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyWorks/GetCompanyWorksRealEstate',
      'POST',
      true,
      body,
    );
  }

  getCompanyWorksPartner(body: EmpresaObrasPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanyWorks/GetCompanyWorksPartner',
      'POST',
      true,
      body,
    );
  }

  getCompanyWorksSimple(empresaId: number, moduleId: string): Observable<any> {
  return this._requestService.requestMethod(
    `company/api/CompanyWorks/GetCompanyWorksSimple/${empresaId}?moduleId=${moduleId}`,
    'GET',
    true,
    null,
  );
}

saveSearch(body: SalvarBuscaEmpresaPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanySavedSearch/SaveSearch',
      'POST',
      true,
      body,
    );
  }

  listSavedSearches(responsibleId: number, page = 1, pageSize = 50): Observable<any> {
  return this._requestService.requestMethod(
    'company/api/CompanySavedSearch/ListSavedSearches',
    'POST',
    true,
    {
      responsibleID: responsibleId,
      pagination: { page, pageSize, shortcuts: 10, ordenation: '' },
    },
  );
  }

  listSavedSearchesSelect(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanySavedSearch/ListSavedSearchesSelect',
      'GET',
      true,
      null,
    );
  }

  loadSavedSearch(savedSearchId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanySavedSearch/${savedSearchId}/LoadSavedSearch`,
      'GET',
      true,
      null,
    );
  }

  editSavedSearch(body: EditarBuscaEmpresaPayload): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/CompanySavedSearch/EditSearch',
      'PUT',
      true,
      body,
    );
  }

  deleteSavedSearch(savedSearchId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanySavedSearch/${savedSearchId}/DeleteSearch`,
      'DELETE',
      true,
      null,
    );
  }

  assignResponsible(empresaIds: number[], responsibleId: number, moduleId: string): Observable<any> {
  return this._requestService.requestMethod(
    'company/api/Company/AssignResponsible',
    'POST',
    true,
    { empresaIds, responsibleId, moduleId },
    );
  }

  addResponsible(savedSearchId: number, responsibleId: number): Observable<any> {
  return this._requestService.requestMethod(
    `company/api/CompanySavedSearch/${savedSearchId}/AddResponsible`,
    'POST',
    true,
    responsibleId,
  );
}

  listResponsibles(savedSearchId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanySavedSearch/${savedSearchId}/ListResponsibles`,
      'GET',
      true,
      null,
    );
  }

  removeResponsible(savedSearchId: number, responsibleId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/CompanySavedSearch/${savedSearchId}/RemoveResponsible/${responsibleId}`,
      'DELETE',
      true,
      null,
    );
 }

    portfolioOverview(teamView = false, responsibleId = 0): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/Company/GetPortfolioOverview?teamView=${teamView}&responsibleId=${responsibleId}`,
      'GET',
      true,
      null,
    );
  }

  portfolioNewWorks(teamView = false, page = 1, pageSize = 10): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/Company/GetPortfolioNewWorks?teamView=${teamView}&page=${page}&pageSize=${pageSize}`,
      'GET',
      true,
      null,
    );
  }

  portfolioCompanies(body: any): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/Company/GetPortfolioCompanies',
      'POST',
      true,
      body,
    );
  }

  removeFromPortfolio(empresaId: number): Observable<any> {
    return this._requestService.requestMethod(
      `company/api/Company/${empresaId}/RemoveFromPortfolio`,
      'DELETE',
      true,
      null,
    );
  }

    listCompanyByName(body: any): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/Company/ListCompanyByName',
      'POST',
      true,
      body,
    );
  }
  reportErroEmpresa(data: any): Observable<any> {
    return this._requestService.requestMethod(
      'company/reports/empresas',
      'POST',
      true,
      data,
    );
  }

    listPositions(): Observable<any> {
    return this._requestService.requestMethod(
      'company/api/Company/ListPositions',
      'GET',
      true,
      null,
    );
  }


}

